import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { getAllPayments, searchPayment } from "../../../../api/apiServices";
import Pagination from "../../../../services/Pagination";
import toast, { Toaster } from "react-hot-toast";
import PaymentSearchBar from "../../../Common/Search/PaymentSearchBar";

const PaymentTransactions = (props) => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/payment_transactions";
	const [country, setCountry] = useState("gh");

	const [search, setSearch] = useState(false);
	const [member, setMember] = useState([]);

	const [searchCriteria, setSearchCriteria] = useState({
		pf_number: "",
		mobile_number: "",
		first_name: "",
		last_name: "",
	});

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(10);

	const {
		isLoading,
		isError,
		error,
		data: payments,
	} = useQuery("payments", getAllPayments, {
		select: (data) => data.sort((a, b) => b.id - a.id),
	});

	let total_payments = payments?.length;

	const handleCancel = () => {
		setSearchCriteria({
			pf_number: "",
			mobile_number: "233",
			first_name: "",
			last_name: "",
		});
		setCountry("gh");
		setSearch(false);
		navigate(from, { replace: true });
	};

	let currentPosts = [];
	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	if (!search) {
		currentPosts = payments?.slice(indexOfFirstPage, indexOfLastPage);
	} else {
		currentPosts = member?.slice(indexOfFirstPage, indexOfLastPage);
	}

	let content;
	if (isLoading) {
		content = <p>Loading Payment Transactions...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg">
				<table className="table table-borderless table-striped">
					<thead>
						<tr>
							<th scope="col" style={{ textAlign: "center" }}>
								#
							</th>
							<th scope="col" style={{ textAlign: "center" }}>
								Year
							</th>
							<th scope="col" style={{ whiteSpace: "nowrap" }}>
								PF Number
							</th>
							<th scope="col" style={{ whiteSpace: "normal" }}>
								Name
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Mobile Number
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Payment Date
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Transaction ID
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Amount Paid
							</th>
							<th scope="col" style={{ textAlign: "center" }}>
								ACTION
							</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts.map((paymt, index) => (
							<tr key={paymt.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.year}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{paymt?.pf_number}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{paymt?.members?.first_name +
										" " +
										paymt?.members?.last_name}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.mobile_number}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.payment_date}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.transaction_id}
								</td>
								<td style={{ textAlign: "right" }}>
									{paymt?.payment_amount.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</td>
								<td
									style={{
										whiteSpace: "nowrap",
										textAlign: "center",
									}}
								>
									<div style={{ display: "inline-block" }}>
										<Link
											to={`/view_payment/${paymt?.receipt_number}`}
											className="small"
										>
											<i className="fa fa-eye"></i> view
										</Link>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Payment Transactions - {total_payments}</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<PaymentSearchBar
												payments={payments}
												setSearch={setSearch}
												searchCriteria={searchCriteria}
												setSearchCriteria={
													setSearchCriteria
												}
												setMember={setMember}
												country={country}
											/>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								<div className="row">
									<div className="col-sm-4">
										<Link
											className="btn btn-success btn-block"
											to="/payments_by_period"
										>
											<i className="fa fa-eye"></i>&nbsp;
											&nbsp;Period Payment
										</Link>
										&nbsp; &nbsp;
									</div>
									<div className="col-sm-4">
										<Link
											className="btn btn-success btn-block"
											to="/payments_by_month"
										>
											<i className="fa fa-eye"></i>&nbsp;
											&nbsp;Monthly Payment
										</Link>
										&nbsp; &nbsp;
									</div>
								</div>
								<br />

								{content}
							</div>
							<div className="panel-footer">
								{payments && !search ? (
									<Pagination
										data={payments}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								) : (
									<div className="search-group">
										<button
											type="submit"
											className="btn btn-danger "
											onClick={handleCancel}
										>
											{" "}
											<i className="fa fa-search"></i>{" "}
											Cancel
										</button>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
};

export default PaymentTransactions;
